import { Typography } from "@mui/material";
import { ReactNode } from "react";

interface SectionLabelProps {
  children: ReactNode;
  sx?: object;
}

const SectionLabel = ({ children, sx }: SectionLabelProps) => {
  return (
    <Typography
      sx={{
        mb: 0.75,
        fontSize: 14,
        fontWeight: 700,
        color: "text.secondary",
        textTransform: "uppercase",
        letterSpacing: 0.6,
        ...sx,
      }}>
      {children}
    </Typography>
  );
};

export default SectionLabel;
